<style>
	.box {
		position: fixed;
		color: #fff;
		font-size: 17px;
		background: #262626;
		padding: 10px 20px;
		border-radius: 2px;
		bottom: 5px;
		right: 5px;
	}


@media screen and (min-width: 800px) {
	.box {
		bottom: 10px;
		right: 10px;
	}
}


</style>

<script>
	export let data = '';

</script>


<div class="box">
	<span>

		{data}

	</span>
</div>
